import './App.css';
import LandingPage from "./pages/LandingPage";
import "assets/css/nucleo-icons.css";
import "assets/scss/blk-design-system-react.scss";
import "assets/demo/demo.css";
function App() {
  return (
    <div>
      <LandingPage />
    </div>
  );
}

export default App;
